/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  (function () {
    var NOTE_TEXT = 'I want to waive the delivery signature of my order.';
    var STORAGE_KEYS = ['waive_signature', 'wave_signature'];

    function getPref() {
      for (var i = 0; i < STORAGE_KEYS.length; i++) {
        var key = STORAGE_KEYS[i];
        try {
          var value = localStorage.getItem(key);
          if (value === 'yes' || value === 'no') return value === 'yes';
        } catch (e) {}
      }
      return false;
    }

    function setPref(enabled) {
      var value = enabled ? 'yes' : 'no';
      STORAGE_KEYS.forEach(function (key) {
        try {
          localStorage.setItem(key, value);
        } catch (e) {}
      });
    }

    function updateCart(enabled) {
      var attrValue = enabled ? 'yes' : '';
      var note = enabled ? NOTE_TEXT : '';
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          note: note,
          attributes: {
            waive_signature: attrValue,
            wave_signature: attrValue
          }
        })
      });
    }

    function syncUI() {
      var enabled = getPref();
      document.querySelectorAll('#WaiveSignatureCheckbox').forEach(function (el) {
        el.checked = enabled;
      });
      document.querySelectorAll('#WaiveSignatureAttr, #WaveSignatureAttr').forEach(function (el) {
        el.value = enabled ? 'yes' : '';
      });
    }

    function bind() {
      document.addEventListener('change', function (e) {
        if (e.target && e.target.id === 'WaiveSignatureCheckbox') {
          var enabled = !!e.target.checked;
          setPref(enabled);
          updateCart(enabled).then(function () {
            syncUI();
            // Optional: trigger Palo Alto cart refresh event if needed
            // document.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      bind();
      syncUI();
    });

    // For OS 2.0 section re-renders / drawer refreshes
    document.addEventListener('shopify:section:load', syncUI);
  })();

  (function () {
    function getCustomerTags() {
      var tags = window.theme && Array.isArray(window.theme.customerTags) ? window.theme.customerTags : [];
      return tags.map(function (tag) { return String(tag || '').toLowerCase().trim(); }).filter(Boolean);
    }

    function hasTag(tags, tagName) {
      return tags.indexOf(tagName) !== -1;
    }

    function getApprovedPro(tags) {
      return hasTag(tags, 'wholesale') || hasTag(tags, 'verified') || hasTag(tags, 'vip');
    }

    function hideApprovedAccountPendingMessage() {
      if (!window.location.pathname || window.location.pathname.indexOf('/account') !== 0) return;

      var tags = getCustomerTags();
      if (!getApprovedPro(tags)) return;

      document.querySelectorAll('[data-pending-verification], .pending-verification').forEach(function (el) {
        el.style.display = 'none';
      });

      document.querySelectorAll('p, div, span, li').forEach(function (el) {
        var txt = (el.textContent || '').toLowerCase();
        if (txt.indexOf('pending verification') !== -1) {
          el.style.display = 'none';
        }
      });
    }

    document.addEventListener('DOMContentLoaded', hideApprovedAccountPendingMessage);
    document.addEventListener('shopify:section:load', hideApprovedAccountPendingMessage);
  })();

  (function () {
    var BUTTON_CLASS_PREFIX = 'sm--add-course-button-';
    var ADDING_CLASS = 'is-adding';
    var CART_VERIFY_ATTEMPTS = 4;
    var CART_VERIFY_DELAY_MS = 200;
    var USER_ERROR = 'Could not add to cart. Please try again.';

    var courseConfig = {};

    function loadCourseConfig() {
      var el = document.getElementById('sm-add-course-config');
      if (!el) return;
      try {
        courseConfig = JSON.parse(el.textContent) || {};
      } catch (e) {
        console.error('sm-add-course-button: invalid config JSON', e);
      }
    }

    function getRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function getCourseKey(btn) {
      var explicit = btn.getAttribute('data-course-key');
      if (explicit) return explicit;

      for (var i = 0; i < btn.classList.length; i++) {
        var cls = btn.classList[i];
        if (cls.indexOf(BUTTON_CLASS_PREFIX) === 0) {
          return cls.slice(BUTTON_CLASS_PREFIX.length);
        }
      }
      return null;
    }

    function fetchVariantIdByHandle(handle) {
      return fetch(getRoot() + 'products/' + handle + '.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product not found: ' + handle);
          return response.json();
        })
        .then(function (product) {
          var variant = product.variants && product.variants.find(function (v) { return v.available; });
          return variant ? parseInt(variant.id, 10) : NaN;
        });
    }

    function resolveVariantId(btn) {
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (Number.isFinite(variantId)) return Promise.resolve(variantId);

      var handle = btn.getAttribute('data-product-handle');
      if (handle) return fetchVariantIdByHandle(handle);

      var courseKey = getCourseKey(btn);
      if (courseKey && courseConfig[courseKey] && courseConfig[courseKey].variantId) {
        return Promise.resolve(parseInt(courseConfig[courseKey].variantId, 10));
      }

      if (courseKey && courseConfig[courseKey] && courseConfig[courseKey].handle) {
        return fetchVariantIdByHandle(courseConfig[courseKey].handle);
      }

      return Promise.resolve(NaN);
    }

    function cartContainsVariant(cart, variantId) {
      return cart.items && cart.items.some(function (item) {
        return item.variant_id === variantId;
      });
    }

    function waitForVariantInCart(variantId, attemptsLeft) {
      return fetch(getRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (cartContainsVariant(cart, variantId)) return cart;
          if (attemptsLeft <= 1) throw new Error('Variant not in cart after add');
          return new Promise(function (resolve) {
            setTimeout(resolve, CART_VERIFY_DELAY_MS);
          }).then(function () {
            return waitForVariantInCart(variantId, attemptsLeft - 1);
          });
        });
    }

    function addCourseButtonToCart(btn) {
      if (btn.classList.contains(ADDING_CLASS)) return;

      resolveVariantId(btn).then(function (variantId) {
        if (!Number.isFinite(variantId)) {
          console.warn('sm-add-course-button: no variant resolved for button', btn);
          return;
        }

        btn.classList.add(ADDING_CLASS);
        btn.setAttribute('aria-busy', 'true');

        fetch(getRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok || data.status) {
                throw new Error(data.description || data.message || 'Add to cart failed');
              }
              return data;
            });
          })
          .then(function () {
            return waitForVariantInCart(variantId, CART_VERIFY_ATTEMPTS);
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          })
          .catch(function (err) {
            console.error('sm-add-course-button:', err);
            alert(USER_ERROR);
          })
          .finally(function () {
            btn.classList.remove(ADDING_CLASS);
            btn.removeAttribute('aria-busy');
          });
      });
    }

    loadCourseConfig();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[class*="sm--add-course-button-"]');
      if (!btn) return;
      e.preventDefault();
      addCourseButtonToCart(btn);
    });

    document.addEventListener('shopify:section:load', loadCourseConfig);
  })();

  (function () {
    var STORAGE_KEY = 'haircare_opt_in';
    var BUSY_CLASS = 'is-busy';
    var CART_SECTION_ID = 'api-cart-items';
    var resolvedVariantId = null;
    var busy = false;
    var syncTimer = null;
    var suppressHaircareAutoAdd = false;

    function getConfig() {
      return (window.theme && window.theme.haircare) || {};
    }

    function getRoot() {
      return (window.theme && window.theme.routes && window.theme.routes.root) || '/';
    }

    function isConfigured(config) {
      config = config || getConfig();
      return !!config.enabled && (!!config.variantId || !!config.productHandle);
    }

    function formatMoney(cents) {
      if (window.theme && typeof window.theme.formatMoney === 'function') {
        return window.theme.formatMoney(cents, window.theme.moneyWithCurrencyFormat);
      }
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, (window.theme && window.theme.moneyWithCurrencyFormat) || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function getPref() {
      try {
        var value = localStorage.getItem(STORAGE_KEY);
        if (value === 'yes' || value === 'no') return value === 'yes';
      } catch (e) {}
      return false;
    }

    function setPref(enabled) {
      try {
        localStorage.setItem(STORAGE_KEY, enabled ? 'yes' : 'no');
      } catch (e) {}
    }

    function fetchCart() {
      return fetch(getRoot() + 'cart.js', {
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        return response.json();
      });
    }

    function fetchVariantIdByHandle(handle) {
      return fetch(getRoot() + 'products/' + handle + '.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HairCare product not found: ' + handle);
          return response.json();
        })
        .then(function (product) {
          var variant = product.variants && product.variants.find(function (v) {
            return v.available;
          });
          return variant ? parseInt(variant.id, 10) : NaN;
        });
    }

    function resolveVariantId(config) {
      config = config || getConfig();
      if (Number.isFinite(resolvedVariantId)) return Promise.resolve(resolvedVariantId);
      if (Number.isFinite(config.variantId)) {
        resolvedVariantId = parseInt(config.variantId, 10);
        return Promise.resolve(resolvedVariantId);
      }
      if (config.productHandle) {
        return fetchVariantIdByHandle(config.productHandle).then(function (variantId) {
          if (Number.isFinite(variantId)) resolvedVariantId = variantId;
          return variantId;
        });
      }
      return Promise.resolve(NaN);
    }

    function getVariantId(config) {
      config = config || getConfig();
      if (Number.isFinite(resolvedVariantId)) return resolvedVariantId;
      if (Number.isFinite(config.variantId)) return parseInt(config.variantId, 10);
      return NaN;
    }

    function isHaircareLine(item, config) {
      if (!item) return false;
      var variantId = getVariantId(config);
      if (Number.isFinite(variantId) && item.variant_id === variantId) return true;
      if (item.properties && item.properties._haircare === 'yes') return true;
      return false;
    }

    function findHaircareLine(cart, config) {
      if (!cart || !cart.items) return null;
      for (var i = 0; i < cart.items.length; i++) {
        if (isHaircareLine(cart.items[i], config)) return cart.items[i];
      }
      return null;
    }

    function buildEligibilityMap() {
      var map = {};

      document.querySelectorAll('[data-cart-item]').forEach(function (el) {
        var key = el.getAttribute('data-line-key') || el.getAttribute('data-item');
        if (!key) return;
        map[key] = el.getAttribute('data-haircare-eligible') === 'true';
      });

      return map;
    }

    function getEligibleSubtotal(cart, config) {
      var eligibilityMap = buildEligibilityMap();
      var total = 0;

      if (cart && cart.items) {
        cart.items.forEach(function (item) {
          if (isHaircareLine(item, config)) return;
          if (eligibilityMap[item.key]) {
            total += item.final_line_price;
          }
        });
      }

      if (total > 0) return total;

      document.querySelectorAll('[data-cart-item][data-haircare-eligible="true"]').forEach(function (el) {
        var price = parseInt(el.getAttribute('data-line-final-price'), 10);
        if (!isNaN(price)) total += price;
      });

      return total;
    }

    function getEligibleSubtotalFromDOM() {
      return getEligibleSubtotal(null, getConfig());
    }

    function haircareLineInCartFromDOM() {
      return document.querySelector('[data-cart-item][data-haircare-line="true"]') !== null;
    }

    function getHaircareLineKeyFromDOM() {
      var el = document.querySelector('[data-cart-item][data-haircare-line="true"]');
      if (!el) return null;
      return el.getAttribute('data-line-key') || el.getAttribute('data-item');
    }

    function isCartDrawerOpen() {
      return document.body.classList.contains('js-drawer-open-cart');
    }

    function refreshCartIfOpen() {
      if (isCartDrawerOpen()) {
        refreshCart();
      }
    }

    function updateHaircareLineVisibility(eligibleSubtotal) {
      document.querySelectorAll('[data-cart-item][data-haircare-line="true"]').forEach(function (el) {
        el.hidden = eligibleSubtotal <= 0;
      });
    }

    function syncPresentationFromDOM() {
      var config = getConfig();
      if (!isConfigured(config)) return;

      var eligibleSubtotal = getEligibleSubtotalFromDOM();
      var inCart = haircareLineInCartFromDOM();
      var checked = eligibleSubtotal > 0 && (inCart || getPref());

      updateHaircareLineVisibility(eligibleSubtotal);
      syncCheckboxUI(checked);
      updateWidgetPresentation(eligibleSubtotal, config, inCart);

      if (eligibleSubtotal <= 0 && inCart && !busy && !suppressHaircareAutoAdd) {
        removeOrphanHaircare();
      }
    }

    function needsHaircareEnforce(domEligible, domInCart) {
      if (suppressHaircareAutoAdd || busy) return false;
      return domEligible > 0 && getPref() && !domInCart;
    }

    function rebindCartInteractions() {
      document.querySelectorAll('cart-element').forEach(function (cartEl) {
        if (typeof cartEl.assignArguments === 'function') {
          cartEl.assignArguments();
        }
        if (typeof cartEl.cartEvents === 'function') {
          cartEl.cartEvents();
        }
        if (typeof cartEl.initCartUpdate === 'function') {
          cartEl.initCartUpdate();
        }
      });
    }

    function clearHaircarePreference() {
      suppressHaircareAutoAdd = true;
      setPref(false);
      syncCheckboxUI(false);
      updateHaircareAttribute(false).catch(function () {});
      window.setTimeout(function () {
        suppressHaircareAutoAdd = false;
      }, 1500);
    }

    function applyApiCartSection(html) {
      if (!html) return false;

      var element = document.createElement('div');
      element.innerHTML = html;
      var data = element.querySelector('[data-api-content]');
      if (!data) return false;

      var cartItemsData = data.querySelector('[data-api-line-items]');
      var upsellItemsData = data.querySelector('[data-api-upsell-items]');
      var priceData = data.querySelector('[data-api-cart-price]');
      var cartTotal = data.querySelector('[data-cart-total]');

      if (cartItemsData) {
        document.querySelectorAll('[data-items-holder]').forEach(function (holder) {
          holder.innerHTML = cartItemsData.innerHTML;
        });
      } else {
        document.querySelectorAll('[data-items-holder]').forEach(function (holder) {
          holder.innerHTML = '';
        });
      }

      document.querySelectorAll('[data-pair-products-holder]').forEach(function (holder) {
        if (upsellItemsData) {
          holder.innerHTML = upsellItemsData.innerHTML;
        } else {
          holder.innerHTML = '';
        }
      });

      if (priceData) {
        document.querySelectorAll('[data-cart-price-holder]').forEach(function (holder) {
          holder.innerHTML = priceData.innerHTML;
        });
      }

      if (cartTotal && cartTotal.hasAttribute('data-cart-total')) {
        var subtotal = parseInt(cartTotal.getAttribute('data-cart-total'), 10);
        if (!isNaN(subtotal)) {
          var formatted =
            subtotal === 0
              ? (window.theme && window.theme.strings && window.theme.strings.free) || 'Free'
              : formatMoney(subtotal);

          document.querySelectorAll('[data-cart-total-price]').forEach(function (el) {
            el.innerHTML = formatted;
          });
        }
      }

      rebindCartInteractions();
      syncPresentationFromDOM();
      return true;
    }

    function cartRequestOptions(options) {
      options = options || {};
      if (!options.sections) return {};

      return {
        sections: options.sections,
        sections_url: options.sectionsUrl || getRoot() + 'cart'
      };
    }

    function applyCartSectionsFromResponse(data, options) {
      if (!options || !options.sections || !data || !data.sections) return false;
      return applyApiCartSection(data.sections[options.sections]);
    }

    function calculateHaircarePrice(eligibleSubtotal, config) {
      var percentage = config.percentage || 15;
      return Math.round(eligibleSubtotal * percentage / 100);
    }

    function updateWidgetPresentation(eligibleSubtotal, config, haircareInCart) {
      var price = calculateHaircarePrice(eligibleSubtotal, config);
      var percentage = config.percentage || 15;
      var widgets = document.querySelectorAll('[data-haircare-widget]');

      widgets.forEach(function (widget) {
        widget.hidden = eligibleSubtotal <= 0;
        widget.setAttribute('data-haircare-eligible-subtotal', eligibleSubtotal);
        widget.setAttribute('data-haircare-price', price);
        widget.setAttribute('data-haircare-in-cart', haircareInCart ? 'true' : 'false');

        var label = widget.querySelector('[data-haircare-label]');
        if (label) {
          label.innerHTML =
            'Add Hairlocs HairCare protection' +
            (price > 0 ? ': ' + formatMoney(price) + ' (' + percentage + '%)' : '');
        }
      });
    }

    function syncCheckboxUI(checked) {
      document.querySelectorAll('[data-haircare-checkbox]').forEach(function (el) {
        el.checked = !!checked;
        el.disabled = busy;
      });
      document.querySelectorAll('#HaircareOptInAttr').forEach(function (el) {
        el.value = checked ? 'yes' : '';
      });
    }

    function updateHaircareAttribute(enabled) {
      return fetch(getRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            haircare_opt_in: enabled ? 'yes' : ''
          }
        })
      });
    }

    function addHaircareLine(variantId, options) {
      options = options || {};
      var payload = Object.assign(
        {
          id: variantId,
          quantity: 1,
          properties: {
            _haircare: 'yes'
          }
        },
        cartRequestOptions(options)
      );

      return fetch(getRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Could not add HairCare protection.');
          }
          applyCartSectionsFromResponse(data, options);
          return data;
        });
      });
    }

    function removeHaircareLine(lineKey, options) {
      options = options || {};
      var payload = Object.assign(
        {
          id: lineKey,
          quantity: 0
        },
        cartRequestOptions(options)
      );

      return fetch(getRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Could not remove HairCare protection.');
          }
          applyCartSectionsFromResponse(data, options);
          return data;
        });
      });
    }

    function setBusy(nextBusy) {
      busy = nextBusy;
      document.querySelectorAll('[data-haircare-widget]').forEach(function (widget) {
        widget.classList.toggle(BUSY_CLASS, busy);
      });
      document.querySelectorAll('[data-haircare-checkbox]').forEach(function (el) {
        el.disabled = busy;
      });
    }

    function refreshCart() {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    }

    function hasHaircareWidget() {
      return document.querySelector('[data-haircare-widget]') !== null;
    }

    function injectHaircareWidget(html) {
      var parser = document.createElement('div');
      parser.innerHTML = html;
      var apiWidget = parser.querySelector('[data-api-haircare-widget]');

      if (!apiWidget) return false;

      var widgetHtml = apiWidget.innerHTML.trim();
      if (!widgetHtml) return false;

      document.querySelectorAll('[data-haircare-widget-mount]').forEach(function (mount) {
        if (!mount.querySelector('[data-haircare-widget]')) {
          mount.innerHTML = widgetHtml;
        }
      });

      return hasHaircareWidget();
    }

    function ensureHaircareWidgets() {
      var config = getConfig();
      if (!isConfigured(config) || hasHaircareWidget()) {
        return Promise.resolve();
      }

      return fetch(getRoot() + 'cart?section_id=api-cart-items', {
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          injectHaircareWidget(html);
        })
        .catch(function (err) {
          console.error('haircare: could not inject widget', err);
        });
    }

    function removeOrphanHaircare() {
      if (busy) return Promise.resolve();

      var config = getConfig();
      var haircareLineKey = getHaircareLineKeyFromDOM();
      if (!haircareLineKey) return Promise.resolve();

      var sectionOptions = { sections: CART_SECTION_ID };

      suppressHaircareAutoAdd = true;
      setPref(false);
      syncCheckboxUI(false);
      updateWidgetPresentation(0, config, false);
      updateHaircareLineVisibility(0);
      setBusy(true);

      return removeHaircareLine(haircareLineKey, sectionOptions)
        .then(function () {
          return updateHaircareAttribute(false);
        })
        .then(function () {
          syncPresentationFromDOM();
        })
        .catch(function (err) {
          console.error('haircare:', err);
          refreshCartIfOpen();
        })
        .finally(function () {
          setBusy(false);
          window.setTimeout(function () {
            suppressHaircareAutoAdd = false;
          }, 1500);
        });
    }

    function enforceHaircareState(options) {
      options = options || {};
      var config = getConfig();
      if (!isConfigured(config)) return Promise.resolve();

      var sectionOptions = { sections: CART_SECTION_ID };
      var useSections = options.useSections !== false;

      return Promise.resolve()
        .then(function () {
          var eligibleSubtotal = getEligibleSubtotalFromDOM();
          var haircareLineKey = getHaircareLineKeyFromDOM();
          var shouldHaveHaircare =
            typeof options.forceChecked === 'undefined' ? getPref() || !!haircareLineKey : !!options.forceChecked;

          if (eligibleSubtotal <= 0 && haircareLineKey) {
            shouldHaveHaircare = false;
            return removeHaircareLine(haircareLineKey, useSections ? sectionOptions : null);
          }

          if (eligibleSubtotal > 0 && shouldHaveHaircare && !haircareLineKey) {
            return resolveVariantId(config).then(function (variantId) {
              if (!Number.isFinite(variantId)) return;
              return addHaircareLine(variantId, useSections ? sectionOptions : null);
            });
          }

          if (!shouldHaveHaircare && haircareLineKey) {
            return removeHaircareLine(haircareLineKey, useSections ? sectionOptions : null);
          }
        })
        .then(function () {
          var inCart = haircareLineInCartFromDOM();
          var finalEligibleSubtotal = getEligibleSubtotalFromDOM();
          var checked = finalEligibleSubtotal > 0 && inCart;

          setPref(checked);
          syncCheckboxUI(checked);
          updateWidgetPresentation(finalEligibleSubtotal, config, inCart);
          return updateHaircareAttribute(checked);
        })
        .then(function () {
          if (options.mutated && options.refresh !== false && !useSections) {
            refreshCartIfOpen();
          }
        });
    }

    function handleCheckboxChange(enabled) {
      var config = getConfig();
      if (!isConfigured(config) || busy) return;

      setBusy(true);
      setPref(enabled);

      var sectionOptions = { sections: CART_SECTION_ID };

      resolveVariantId(config)
        .then(function (variantId) {
          var haircareLineKey = getHaircareLineKeyFromDOM();
          var eligibleSubtotal = getEligibleSubtotalFromDOM();

          if (!enabled) {
            if (!haircareLineKey) {
              return updateHaircareAttribute(false).then(function () {
                syncCheckboxUI(false);
                updateWidgetPresentation(eligibleSubtotal, config, false);
              });
            }

            return removeHaircareLine(haircareLineKey, sectionOptions).then(function () {
              return updateHaircareAttribute(false);
            });
          }

          if (eligibleSubtotal <= 0) {
            throw new Error('Add eligible hair extensions before selecting HairCare protection.');
          }

          if (haircareLineKey) {
            return updateHaircareAttribute(true);
          }

          if (!Number.isFinite(variantId)) {
            throw new Error('HairCare product is not configured. Add a variant ID in Theme settings.');
          }

          return addHaircareLine(variantId, sectionOptions).then(function () {
            return updateHaircareAttribute(true);
          });
        })
        .then(function () {
          syncPresentationFromDOM();
        })
        .catch(function (err) {
          console.error('haircare:', err);
          alert(err.message || 'Could not update HairCare protection. Please try again.');
          return enforceHaircareState({ refresh: false });
        })
        .finally(function () {
          setBusy(false);
        });
    }

    function syncFromCartAsync() {
      var config = getConfig();
      if (!isConfigured(config)) return;

      ensureHaircareWidgets().then(function () {
        var domEligible = getEligibleSubtotalFromDOM();
        var domInCart = haircareLineInCartFromDOM();

        if (!needsHaircareEnforce(domEligible, domInCart)) {
          return;
        }

        if (domEligible > 0 && getPref() && !domInCart) {
          return enforceHaircareState({ forceChecked: true, mutated: true, useSections: true });
        }
      });
    }

    function syncFromCartDOM() {
      var config = getConfig();
      if (!isConfigured(config)) return;

      syncPresentationFromDOM();

      if (syncTimer) {
        clearTimeout(syncTimer);
      }

      syncTimer = setTimeout(syncFromCartAsync, 0);
    }

    function isCollectionPage() {
      var path = window.location.pathname || '';
      return path.indexOf('/collections/') !== -1;
    }

    function bindHaircareEvents() {
      document.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-item-remove]');
        if (!removeBtn) return;

        var item = removeBtn.closest('[data-cart-item]');
        if (!item || item.getAttribute('data-haircare-line') !== 'true') return;

        clearHaircarePreference();
      }, true);

      document.addEventListener('change', function (e) {
        if (e.target && e.target.matches('[data-haircare-checkbox]')) {
          handleCheckboxChange(!!e.target.checked);
        }
      });

      document.addEventListener('theme:cart:loaded', syncFromCartDOM);
      document.addEventListener('theme:cart:added', syncFromCartDOM);
      document.addEventListener('theme:cart:change', syncFromCartDOM);
      document.addEventListener('shopify:section:load', syncFromCartDOM);
    }

    document.addEventListener('DOMContentLoaded', function () {
      bindHaircareEvents();
      if (!isCollectionPage()) {
        syncFromCartDOM();
      }
    });
  })();






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
